import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useCallback, useMemo, useState } from "react";
import { Button } from "reactstrap";
import Modal from "../../../../Basic/Modal";
import CommonLoad from "../../../../Basic/Spin";
import { getTransFunc } from '../../../../Basic/SFxLocalization';
import { prefix } from '../../index';

var useModal = function useModal(handlerModalOk, handlerModalRest, handlerModalClose) {
  var translate = getTransFunc();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showReset = _useState4[0],
      setShowReset = _useState4[1];

  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      title = _useState6[0],
      setTitle = _useState6[1];

  var _useState7 = useState(translate('SFxAccountSettingsCancelButtonText')),
      _useState8 = _slicedToArray(_useState7, 2),
      cancelText = _useState8[0],
      setCancelText = _useState8[1];

  var _useState9 = useState('Ok'),
      _useState10 = _slicedToArray(_useState9, 2),
      okText = _useState10[0],
      setOkText = _useState10[1];

  var _useState11 = useState(''),
      _useState12 = _slicedToArray(_useState11, 2),
      contentTitle = _useState12[0],
      setContentTitle = _useState12[1];

  var _useState13 = useState(false),
      _useState14 = _slicedToArray(_useState13, 2),
      showModalLoading = _useState14[0],
      setShowModalLoading = _useState14[1];

  var _useState15 = useState(false),
      _useState16 = _slicedToArray(_useState15, 2),
      disableOk = _useState16[0],
      setDisableOk = _useState16[1];

  var _useState17 = useState(false),
      _useState18 = _slicedToArray(_useState17, 2),
      hideOk = _useState18[0],
      setHideOk = _useState18[1];

  var _useState19 = useState(false),
      _useState20 = _slicedToArray(_useState19, 2),
      hideCancel = _useState20[0],
      setHideCancel = _useState20[1];

  var open = useCallback(function (_ref) {
    var title = _ref.title,
        contentTitle = _ref.contentTitle,
        okText = _ref.okText,
        cancelText = _ref.cancelText,
        isShowRest = _ref.isShowRest,
        disableOk = _ref.disableOk,
        hideOk = _ref.hideOk,
        hideCancel = _ref.hideCancel;
    setVisible(true);
    if (isShowRest !== undefined) setShowReset(isShowRest);
    setOkText(okText);
    if (cancelText) setCancelText(cancelText);
    setTitle(title);

    if (contentTitle) {
      setContentTitle(contentTitle);
    } else {
      setContentTitle('');
    }

    if (disableOk !== undefined) {
      setDisableOk(disableOk);
    }

    if (hideOk !== undefined) {
      setHideOk(hideOk);
    }

    if (hideCancel !== undefined) {
      setHideCancel(hideCancel);
    }
  }, [setVisible, setShowReset, setOkText, setTitle]);
  var close = useCallback(function () {
    setVisible(false);
  }, [setVisible]);
  var toggle = useCallback(function () {
    if (visible) {
      handlerModalClose && handlerModalClose();
    }

    setVisible(!visible);
  }, [visible, setVisible, handlerModalClose]);
  var handleCancel = useCallback(function () {
    setVisible(false);
  }, [setVisible]);
  var handleOk = useCallback(function () {
    handlerModalOk && handlerModalOk();
  }, [handlerModalOk]);
  var updateDisableOk = useCallback(function (disableOk) {
    setDisableOk(disableOk);
  }, []);
  var updateShowReset = useCallback(function (showReset) {
    setShowReset(showReset);
  }, []);
  var handlerReset = useCallback(function () {
    handlerModalRest && handlerModalRest();
  }, [handlerModalRest]);
  var footer = useMemo(function () {
    return /*#__PURE__*/React.createElement("div", {
      className: "modal-footer user-modal-footer"
    }, showReset && /*#__PURE__*/React.createElement("span", {
      className: "reset-text",
      onClick: handlerReset
    }, /*#__PURE__*/React.createElement("span", {
      className: "reset-button"
    }, translate('SFxAccountSettingsResetButtonText'))), /*#__PURE__*/React.createElement("span", null, !hideCancel && /*#__PURE__*/React.createElement(Button, {
      color: "secondary",
      onClick: handleCancel
    }, cancelText), !hideOk && /*#__PURE__*/React.createElement(Button, {
      color: "primary",
      disabled: disableOk,
      onClick: handleOk
    }, okText)));
  }, [showReset, handlerReset, translate, hideCancel, handleCancel, cancelText, hideOk, disableOk, handleOk, okText]);

  var renderModal = function renderModal(_ref2) {
    var children = _ref2.children;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal, {
      centered: true,
      isOpen: visible,
      backdrop: "static",
      className: "account-settings-modal",
      title: title,
      toggle: toggle,
      footer: null
    }, showModalLoading && /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefix, "-mask")
    }, /*#__PURE__*/React.createElement(CommonLoad, {
      size: 0.2
    })), contentTitle && /*#__PURE__*/React.createElement("h3", null, contentTitle), children, footer));
  };

  var updateShowModalLoading = function updateShowModalLoading(showLoading) {
    setShowModalLoading(showLoading);
  };

  return [visible, open, close, updateShowModalLoading, updateDisableOk, updateShowReset, renderModal];
};

export default useModal;